import { render, staticRenderFns } from "./corp_info.vue?vue&type=template&id=9d8dee64&scoped=true"
import script from "./corp_info.vue?vue&type=script&lang=js"
export * from "./corp_info.vue?vue&type=script&lang=js"
import style0 from "./corp_info.vue?vue&type=style&index=0&id=9d8dee64&prod&scoped=true&lang=less"
import style1 from "./corp_info.vue?vue&type=style&index=1&id=9d8dee64&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8dee64",
  null
  
)

export default component.exports